// Secure upload session management utility
let sessionTimeoutId = null

const secureUploadSession = {
  async create(expiresInSeconds) {
    if (!expiresInSeconds) {
      return
    }
    const expiresAt = Date.now() + Number(expiresInSeconds) * 1000
    try {
      const storeModule = await import('@/store')
      const store = storeModule.default
      store.commit('globalComponents/setSessionExpiresAt', expiresAt)
    } catch (e) {
      console.error('Error setting sessionExpiresAt in Vuex:', e)
    }
    window.localStorage.setItem('sessionExpiresAt', String(expiresAt))
    return expiresAt
  },
  isExpired(expiresAt) {
    // Treat missing/null/undefined expiresAt as expired
    if (!expiresAt) {
      return true
    }
    const ts = Number(expiresAt)
    return Date.now() >= ts
  },
  async clear() {
    try {
      const storeModule = await import('@/store')
      const store = storeModule.default
      store.commit('globalComponents/setSessionExpiresAt', null)
      store.commit('globalComponents/setIsSecureUploadLogin', false)
      store.commit('globalComponents/setSecureMemberData', null)
      store.commit('globalComponents/setOtpType', null)
      store.commit('secureUpload/logout')
    } catch (e) {
      console.error('Error clearing session in Vuex:', e)
    }
    window.localStorage.removeItem('sessionExpiresAt')
    window.localStorage.removeItem('isSecureUploadLogin')
    window.localStorage.removeItem('secureMemberData')
    window.localStorage.removeItem('otpType')
    window.localStorage.removeItem('secure_phone')
  },

  /**
   * Set a timeout to automatically clear session and run callback when session expires
   * @param {number} expiresAt - Timestamp in ms when session expires
   * @param {Function} callback - Optional callback to run after session is cleared
   */
  setTimeoutLogout(expiresAt, callback) {
    if (!expiresAt) {
      return
    }
    const ms = Number(expiresAt) - Date.now()
    if (ms <= 0) {
      this.clear()
      if (typeof callback === 'function') {
        callback()
      }
      return
    }
    if (sessionTimeoutId) {
      clearTimeout(sessionTimeoutId)
    }
    sessionTimeoutId = setTimeout(async () => {
      await this.clear()
      if (typeof callback === 'function') {
        callback()
      }
    }, ms)
  },

  clearTimeoutLogout() {
    if (sessionTimeoutId) {
      clearTimeout(sessionTimeoutId)
      sessionTimeoutId = null
    }
  },
}

export default secureUploadSession
